module.exports = __webpack_public_path__ + "images/favicon.ico";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/favicon.ico
// module id = rU96
// module chunks = 153